import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { deleteMBMAVOBBox } from "services/ConfigServices";
import useGatewayTable from "./useGatewayTable.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { avobboxtext } from "variables/MBM/avobbox";
import { typeData,serverTypeLorawanGateway } from "variables/MBM/lists/avobbox";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import GatewaysDialog from "./GatewaysDialog.js";


const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTGateways = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const currentusertype = localStorage.getItem('userType');
  const mbm_admin = permis.includes("mbm_admin") && currentusertype==1; //not in prod yet
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [open, setOpen] = useState(false);
  const [currentAVOBBox, setCurrentAVOBBox] = useState(null);
  const { gridState, refetch, setAvobboxs } = useGatewayTable();

  let dataAVOBBox = gridState.data;

  const classes = useStyles();

  const columns = [
    {
      name: avobboxtext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: avobboxtext.euid,
      selector: (row) => row.gatewayid,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.gatewayid,
    },
    {
      name: avobboxtext.description,
      selector: (row) => row.description,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.description,
    },
    {
      name: avobboxtext.gatewayhardware,
      selector: (row) => row.otherparameters?.hardware || "",
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.otherparameters?.hardware || ""
    },
    {
      name: avobboxtext.servertype,
      selector: (row) => row.otherparameters?.servertype || "",
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.otherparameters?.servertype ? serverTypeLorawanGateway.find((x) => x.id == row.otherparameters.servertype)?.name || "" : "",
    },
    {
      name: avobboxtext.server,
      selector: (row) => row.otherparameters?.server || "",
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.otherparameters?.server  || "",
    },
    {
      name: avobboxtext.lastconnection,
      selector: (row) => row.lastconnection && moment(row.lastconnection).isValid() ? row.lastconnection : 0,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.lastconnection && moment(row.lastconnection).isValid()
          ? moment(row.lastconnection).format("DD/MM/YYYY HH:mm:ss")
          : "",
    },
    {
      name: avobboxtext.group,
      selector: (row) => row.groupid,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {mbm_admin && (
              <>
                <Tooltip title="Editer la box">
                  <Button
                    onClick={editAVOBBox(row)}
                    color={"warning"}
                    className={classes.actionButton}
                  >
                    <EditIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title="Supprimer la box">
                  <CustomDeleteButton
                    deleteTitle={"Suppression de la box"}
                    deleteSubTitle={`Êtes-vous sûr de vouloir supprimer la box' ${row.name}?`}
                    handleSupprimer={deleteAVOBBoxFunction(row)}
                  />
                </Tooltip></>
            )}
          </div>
        </>
      ),
    },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const editAVOBBox = (row) => async () => {
    let obj = dataAVOBBox.find((o) => o.id === row.id);
    if (obj) {
      setCurrentAVOBBox(obj);
      handleClickOpen();
    }
  }

  const deleteAVOBBoxFunction = (row) => async () => {
    let obj = dataAVOBBox.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let type = obj.type;
    let url = deleteMBMAVOBBox(idSelected, type);
    axios
      .delete(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `La box a été supprimée`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setAvobboxs(selection.selectedRows);
  };


  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucune Box à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        expandableRowDisabled={(row) => row.disabled}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          Modification d'une box
        </CustomDialogTitle>
        <DialogContent dividers>
          <GatewaysDialog
            currentBox={currentAVOBBox}
            closeModal={handleEditClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTGateways;
